<template>
  <div
    class="w-block__pre-heading"
    :class="{ 'ml-4 mr-4 mt-3': $voicer.isMobile }"
  >
    <!-- pre-heading block -->
    <v-container v-if="$route.name === 'index'" class="pa-4">
      <v-sheet color="#E5F1F9" dark class="pa-3">
        <div class="black--text">
          <strong>
            Bienvenue sur Radio Papilles ! Radio Papilles, c’est la plateforme
            dédiée aux podcasts audios et vidéos de Sodexo Sogeres Santé
            Médico-social.
          </strong>
          <br />
          Vous souhaitez nous envoyer un message, partager une info ou proposer
          un sujet ?
          <br />
          Ecrivez à
          <a href="mailto:contact@radiopapilles.fr">contact@radiopapilles.fr</a>
        </div>
      </v-sheet>
    </v-container>
  </div>
</template>
<script>
export default {
  components: {},
}
</script>

<style lang="scss" scoped>
.w-block__pre-heading {
  display: flex;
  justify-content: center;
  text-align: center;
}
.v-sheet {
  border-radius: 8px;
}
.v-card {
  border-radius: 8px;
}
</style>
